import ProductCreationCompletePage from "@/pages/ProductCreationCompletePage";
import ProductActionsFunctionalPanel from "@/pages/ProductActionsFunctionalPanel";

export default function ProductProfessionalPage() {
  return <div data-testid="professional-product-page"><ProductCreationCompletePage /><div className="page-wrap"><ProductActionsFunctionalPanel /></div></div>;
}